<template>
  <div id="app">
    <!-- <div class="case_div">
      <img class="home_banner" src="../../static/img/案例顶部图.jpeg" />
      <div class="cover_div"></div>
      <div class="div_top_title">
        <p>健康美食·由此开始</p>
        <p class="p_title_sub">Healthy Food From Here On</p>
      </div>
    </div> -->
    <div>
      <!-- <ShowLine></ShowLine> -->
    </div>
    <div class="list_div menutype">
      <p class="heading">餐饮服务案例</p>
      <div class="row">
        <div v-for="(item, index) in List" :key="index">
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div class="box_card menu-item" @click="CaseDetail(item.id)">
              <div class="card-img icon">
                <img :src="item.cover" />
                <p>{{ item.subtitle }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
          <div class="box_card menu-item">
            <div class="card-img icon">
              <p>. . . . . .</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <p class="more_icon">查看更多</p> -->
    </div>
    <!-- <p class="tv_btn_more" @click="getInfo()">查看更多</p> -->
  </div>
</template>

<script>
import HomeBanner from "./HomeBanner.vue";
import ShowLine from "./ShowLine.vue";
export default {
  components: {
    HomeBanner,
    ShowLine,
  },
  data() {
    return {
      popActive: 0,
      pageCount: 1,
      currentPage: 1,
      isActive: 0,
      menutype: [],
      List: [
        {
          cover: "",
        },
      ],
      cardheight: 0,
    };
  },
  mounted: function () {
    this.Init();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  deactivated() {
    this.$destroy();
  },
  methods: {
    Init() {
      this.getInfo();
    },
    CaseDetail(id) {
      let routeData = this.$router.resolve({
        path: "/Case/id=" + id,
      });
      window.open(routeData.href, "_blank");
    },
    changepop(i) {
      this.isActive = i;
      this.popActive = i;
      if (i == 1) {
        this.url = "api/plate/list";
        this.gettype();
      } else if (i == 2) {
        this.url = "api/business/list";
        this.gettype();
      } else {
        this.getInfo();
      }
    },
    gettype() {
      this.$http.get(this.url, {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.menutype = response.data.page.list;
          }
        }.bind(this)
      );
    },
    getInfo(menutype) {
      let plate = "";
      let business = "";
      let title = "";
      if (sessionStorage.getItem("input") !== "null") {
        title = sessionStorage.getItem("input");
      } else {
        if (this.isActive == 1) {
          plate = menutype;
        } else {
          business = menutype;
        }
      }

      this.$axios
        .get("api/case/list", {
          params: {
            page: 1,
            limit: 999,
            plate: plate,
            business: business,
            title: title,
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.List = response.data.page.list;
              for (let i = 0; i < this.List.length; i++) {
                this.List[i].plates = this.List[i].plates.replaceAll(
                  ",",
                  " / "
                );
                this.List[i].business = this.List[i].business.replaceAll(
                  ",",
                  " / "
                );
              }
              sessionStorage.setItem("input", "null");
            }
          }.bind(this)
        );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.more_icon {
  padding: 1rem 3rem;
  color: var(--textBlue);
  width: fit-content !important;
  margin: 2rem auto;
  border: 1px solid var(--textBlue);
  font-size: 1.6rem;
}
.tv_btn_more {
  padding: 1rem;
  text-align: center;
  margin: auto;
  margin-bottom: 5rem;
  margin-top: 5rem;
  width: 10vw;
  border: 1px solid #000000;
}

.case_div {
  height: 100%;
  position: relative;
}

.cover_div {
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 0);
  top: 0;
  left: 0;
}

.div_top_title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: white;
  font-size: 5rem;
  font-family: regular;

  .p_title_sub {
    font-size: 2rem;
    font-family: regular;
    margin: 0 1rem;
  }

  .litter_line_top {
    margin: auto;
    background-color: white;
    height: 1px;
    width: 20%;
  }
}

.heading {
  padding: 5rem 0 0 0;
  margin-bottom:5rem;
  font-size: 4.5rem;
  color: var(--textBlue);
  text-align: left;
  font-family: regular;
}

.home_banner {
  width: 100%;
  height: 30vw;
  object-fit: cover;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.box_card {
  height: 27rem;
  margin: 2rem;
  position: relative;
}

.list_div {
  padding:10rem 0;
  width: 70vw;
  margin-left: auto;
  margin-right: auto;
}

.card-img {
  width: 90%;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;

  p {
    color: #0a396e;
    font-size: 2.4rem;
    margin: 10px 0;
  }

  img {
    width: 100%;
  }
}

.menutype {
  font-size: 16px;
  justify-content: center;

  .menu-item {
    transition: all 0.4s;
    text-align: center;
    border-radius :3rem;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);

    .icon {
      margin-bottom: 10px;
    }
  }

  .menu-item:hover {
    transform: scale(1.1);
    transition: all 0.4s;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
    cursor: pointer;
  }
}

@media screen and (min-width: 1920px) {
  .card-img {
    img {
      width: 70%;
    }
  }
}

@media screen and (max-width: 1300px) {
  .list_div {
    width: 90vw;
  }

  .card-img {
    img {
      width: 90%;
    }
  }
}

@media (max-width: 800px) {
  .heading {
    margin: 0;
    font-size: 3rem;
  }

  .div_top_title {
    font-size: 2rem;

    .p_title_sub {
      font-size: 1rem;
    }
  }
}
</style>
